import { Pipe, PipeTransform } from '@angular/core';
import { ThaiDatePipe } from './thai-date.pipe';

@Pipe({
  name: 'dateDifference',
  pure: false // ให้เปลี่ยนตามภาษาได้ทันทีเมื่อ lang เปลี่ยน
})
export class DateDifferencePipe implements PipeTransform {

  transform(startingDate: Date, endingDate?: Date, lang: any = 'th'): any {

    // รองรับ lang ได้หลายแบบ: 'th','TH','en','EN','gb','GB','english'
    const l = (lang ?? 'th').toString().toLowerCase();
    const isEn = (l === 'en' || l === 'gb' || l === 'english');

    let startDate = new Date(startingDate);
    if (!endingDate) endingDate = new Date();
    let endDate = new Date(endingDate);

    // swap ถ้า start > end
    if (startDate > endDate) {
      const swap = startDate;
      startDate = endDate;
      endDate = swap;
    }

    // leap year
    const startYear = startDate.getFullYear();
    const february =
      (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0
        ? 29
        : 28;
    const daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    let yearDiff = endDate.getFullYear() - startYear;
    let monthDiff = endDate.getMonth() - startDate.getMonth();
    if (monthDiff < 0) {
      yearDiff--;
      monthDiff += 12;
    }

    let dayDiff = endDate.getDate() - startDate.getDate();
    let hourDiff = endDate.getHours() - startDate.getHours();
    let minuteDiff = endDate.getMinutes() - startDate.getMinutes();
    let secondDiff = endDate.getSeconds() - startDate.getSeconds();

    if (dayDiff < 0) {
      if (monthDiff > 0) monthDiff--;
      else {
        yearDiff--;
        monthDiff = 11;
      }
      dayDiff += daysInMonth[startDate.getMonth()];
    }

    let retString = '';

    // > 2 วัน: แสดงเป็นวัน/เวลา
    if (dayDiff > 2 && monthDiff >= 0 && yearDiff >= 0) {
      if (isEn) {
        // อังกฤษ
        retString = startDate.toLocaleString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } else {
        // ไทย (ใช้ pipe เดิมของคุณ)
        const pipe = new ThaiDatePipe();
        retString = pipe.transform(startingDate.toString(), 'mediumTime', '');
      }
    }

    // 2 วัน
    if (dayDiff === 2 && monthDiff >= 0 && yearDiff >= 0) {
      retString = isEn ? '2 days' : '2 วัน';
    }

    // เมื่อวาน
    if (dayDiff === 1 && monthDiff >= 0 && yearDiff >= 0) {
      if (isEn) {
        retString = `yesterday at ${startDate.toLocaleTimeString('en-GB', {
          hour: '2-digit',
          minute: '2-digit'
        })}`;
      } else {
        const pipe = new ThaiDatePipe();
        retString = 'เมื่อวานนี้ เวลา ' + pipe.transform(startingDate.toString(), 'H:i', '');
      }
    }

    // ชั่วโมง (วันนี้)
    if (hourDiff > 0 && dayDiff === 0 && monthDiff === 0 && yearDiff === 0) {
      retString = isEn
        ? `${hourDiff} hour${hourDiff === 1 ? '' : 's'} ago`
        : `${hourDiff} ชั่วโมง`;
    }

    // นาที (วันนี้)
    if (hourDiff === 0 && dayDiff === 0 && monthDiff === 0 && yearDiff === 0) {
      if (minuteDiff > 0) {
        retString = isEn
          ? `${minuteDiff} minute${minuteDiff === 1 ? '' : 's'} ago`
          : `${minuteDiff} นาที`;
      }
    }

    // เมื่อสักครู่ / just now
    if (
      minuteDiff === 0 &&
      hourDiff === 0 &&
      dayDiff === 0 &&
      monthDiff === 0 &&
      yearDiff === 0
    ) {
      retString = isEn ? 'just now' : 'เมื่อสักครู่';
    }

    return retString;
  }
}
